import React, { useState, useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { NavLink } from 'react-router-dom';
//import { TextPlugin } from 'gsap/TextPlugin';
// import Scrambler from 'scrambling-text';
import './arrowsection.css';

import CountUp from 'react-countup';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import slide1 from '../images/wwd-slider1.webp';
import slide2 from '../images/wwd-slider2.webp';
import slide3 from '../images/wwd-slider3.webp';
import slide4 from '../images/wwd-slider4.webp';
//import { counter } from '@fortawesome/fontawesome-svg-core';


gsap.registerPlugin(ScrollTrigger);


export const ArrowSection = ({setBlank}) => {


  // let navigate = useNavigate();
  
  // const toRedirect = ()=> {
  //   navigate('about');
  // }



  const scrollToTop = () => {
    setBlank(true);
    setTimeout(() => {
    window.scrollTo(0, 0);
    }, 100);
    setTimeout(() => {
    setBlank(false);            
    }, 600);
}

  // Skewed text
  const [sktext, setSktext] = useState("");
  useEffect(() => {
    let sktext = "We are a provider of high‑caliber, AI‑enabled outsourced talent for family offices, asset managers, advisors & corporates globally, functioning as an extension of our clients’ teams across investment, strategy and portfolio reporting functions creating operating leverage, faster decisions, and measurable execution impact.";
    let arr = sktext.split(' ');
    let result = '<span class="rotate"> ' +
      arr.join(' </span><span class="rotate">') +
      '</span>';
    setSktext(result);
  }, [sktext]);


  //   scroll animation
  useEffect(() => {

    gsap.to(".arrowbg", {
      left: 0,
      duration: 5,
      delay: 2,
      scrollTrigger: {
        ease: "power3.out",
        trigger: ".arrowbg",
        // start: "top bottom",
        // end: "top 130vh ",
        start: "top bottom",
        end: "top center",
        scrub: 5
      }
    });

    gsap.to(".counter", {
      opacity: 1,
      duration: 0.1,
      delay: 0,
      scrollTrigger: {
        trigger: ".arrowbg",
        start: "top 300px",
        scrub: false
      }
    });  

   }, [])

  // scramble text


    const stats = [
        {
            count: 150,
            text: "Clients Served",
            prefix: "",
            suffix: "+",
            isAUM: false
        },
        {
            count: 1_200_000_000_000,
            text: "Advised AUM",
            prefix: "$",
            suffix: "+",
            isAUM: true
        },
        {
            count: 20,
            text: "Countries",
            prefix: "",
            suffix: "+",
            isAUM: false
        },
        // {
        //     count: 100,
        //     text: "Team Size",
        //     prefix: "",
        //     suffix: "+",
        //     isAUM: false
        // }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const currentStat = stats[currentIndex];

    // const formatAUM = (value) => {

    //     if (value >= 1_000_000_000_000) {
    //         return (
    //             "$" + (value / 1_000_000_000_000).toFixed(0) +
    //             "Tn"
    //         );
    //     }

    //     return (
    //         "$" + (value / 1_000_000_000).toFixed(0) +
    //         "Bn"
    //     );
    // };

    const formatAUM = (value) => {
      return "$" + (value / 1_000_000_000_000).toFixed(2) + "Tn";
    };
    useEffect(() => {

        const interval = setInterval(() => {

            setCurrentIndex((prevIndex) => {

                // return (prevIndex + 1) % stats.length;
                 return (prevIndex + 1) % 3;

            });

        }, 4000);

        return () => clearInterval(interval);

    }, []);




  // slider data
  const sliderdata = [
    { id: 1, img: slide2, link:'managementconsultingservices',  title: 'Management Consulting', text: "Empowering CXOs to prioritize and execute strategic projects to achieve greater business efficiency and effectiveness" },
    { id: 2, img: slide1, link:'investmentadvisoryservice', title: "Investment Advisory", text: "Complementing investment teams with transaction advisory, valuation and investment research services" },
    { id: 3, img: slide3, link:'aidataService', title: "AI & Data Solutions", text: "Empowering businesses to make data-driven decisions, built on systems that work" },
    { id: 4, img: slide4, link:'cfoservices', title: "CFO Services", text: "Enabling finance leaders with planning, reporting, governance, and performance management through AI-enabled finance capabilities" },
    { id: 1, img: slide2, link:'managementconsultingservices', title: 'Management Consulting', text: "Empowering CXOs to prioritize and execute strategic projects to achieve greater business efficiency and effectiveness" },
    { id: 2, img: slide1, link:'investmentadvisoryservice', title: "Investment Advisory", text: "Complementing investment teams with transaction advisory, valuation and investment research services" },
    { id: 3, img: slide3, link:'aidataService', title: "AI & Data Solutions", text: "Empowering businesses to make data-driven decisions, built on systems that work" },
    { id: 4, img: slide4, link:'cfoservices', title: "CFO Services", text: "Enabling finance leaders with planning, reporting, governance, and performance management through AI-enabled finance capabilities" },
  ];


  const sliderdata2 = [
    { id: 1, img: slide2, link:'managementconsulting',  title: 'Management Consulting', text: "Empowering CXOs prioritize and execute strategic projects to achieve greater business efficiency and effectiveness" },
    { id: 2, img: slide1, link:'investmentadvisory', title: "Investment Advisory", text: "Complementing investment teams with transaction advisory, valuation and investment research services" },
    { id: 3, img: slide3, link:'dataanalytics', title: "AI & Data Solutions", text: "Empowering businesses to make data-driven decisions, built on systems that work" },
    { id: 4, img: slide4, link:'cfoservices', title: "CFO Services", text: "Enabling finance leaders with planning, reporting, governance, and performance management through AI-enabled finance capabilities" },
  ];

  return (
    <>
      <div className='arrow-section desktop'>
        <div className='arrowbg'></div>

        <section className='whowr-section desktop' >
          {/* <div className='whowrbg'></div> */}
          <Container fluid>
            <Row className=' '>

              <Col lg={4} xl={4} xxl={4} className='col-md-4 offset-2 pt-5'>

                <div className='counter pt-5'>
                  <h2 className='count'>
                    <CountUp 
                      key={currentIndex} 
                      start={ currentStat.isAUM ? 100_000_000_000 : 0 } end={currentStat.count} 
                      duration={2} 
                      separator="," 
                      prefix={currentStat.prefix} 
                      suffix={currentStat.suffix} 
                      formattingFn={ currentStat.isAUM ? formatAUM : undefined } 
                    />
                  </h2>

                  <h4 className='counttext' >
                    {currentStat.text}
                    {/* <TextScramble texts={ctext} letterSpeed={1600} nextLetterSpeed={1000}  pauseTime={2500}/> */}
                  </h4>
                </div>
              
              </Col>

              <Col lg={5} xl={5} xxl={5} className='col-md-5 pe-5'>
                <div className='content-box'>
                  <h2>Who</h2>
                  <div className="strok">We Are</div>
                  <div className="h1 anima">We <span className='anima-underline'>Are</span></div>

                  <p className='mt-3 holder' dangerouslySetInnerHTML={{ __html: sktext }}></p>
                  {/* <p className='mt-3 holder' > Preferred Square provides offshore management consulting and investment advisory support to family offices, fund managers and corporates across the globe. Through our long history of consulting projects with Family Offices and LPs, we've developed a unique vantage to enable our clients in critical areas of business ranging from business strategy to portfolio management to transaction advisory</p> */}
                  <NavLink to='/about' onClick={scrollToTop}><button className="findout-btn mt-2 ">Find out more about us</button></NavLink>
                </div>

              </Col>

            </Row>
          </Container>

        </section>

        {/* <section className='mobile' >
            <Container className='whowr-section mobile'>
            <div></div> 
            </Container>
              <Container>
                <Row>
                <p className='mobile-para' dangerouslySetInnerHTML={{__html: sktext}}></p>
                </Row>
              </Container>

        </section>   */}
        <section className='wherewd-section' >
          {/* <div className='wherewdbg'></div> */}
          <Container fluid>
            <Row className='w-100 ps-5'>

              <Col className='col-md-11 mt-5 offset-1'>
                <div className='content-box'>
                  <h2>Where do we</h2>
                  <div className="strok">Create Impact</div>
                  <div className="h1 anima">Create  <span className='anima-underline'>Impact</span></div>
                </div>


              </Col>

              <Col className='col-md-8 pt-5 offset-3 '>

                <div >

                  <Swiper
                    slidesPerView={3}
                    spaceBetween={0}
                    centeredSlides={false}
                    loop={true}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    // pagination={{
                    //   clickable: false,
                    // }}
                    pagination={false}
                    navigation={true}
                    //modules={[ Pagination, Navigation]}
                    modules={[Autoplay, Pagination, Navigation]}
                    className="mySwiper"
                  >

                    {sliderdata.map((d, i) => (
                      <SwiperSlide key={i}>
                        <div className="slide-box">
                          <img src={d.img} alt="" />
                          <NavLink to={`/${d.link}`} onClick={scrollToTop}>
                          <div className="text-box">
                            <div className="heading">{d.title} </div>
                            <div className="text">{d.text} </div>
                          </div></NavLink>
                        </div>

                      </SwiperSlide>
                    ))}


                  </Swiper>
                </div>

                <NavLink to='/service' onClick={scrollToTop}><button className="findout-btn center mt-5 ">Find out more about us</button></NavLink>


              </Col>


            </Row>
          </Container>
        </section>
      </div>

      <div className='arrow-section mobile'>
        <section className='arrow-section arrow-mobile' >
          <Container fluid>
            <div className='content-box mb-5'>
              <div className='heading-box'>
                <h2>Who</h2>
                <div className="strok">We Are</div>
                <div className="h1 anima">We <span className='anima-underline'>Are</span></div>
              </div>
            </div>
          </Container>
          <Container className='mt-5 pt-4 arrow-section-bg'>
            <Row>
              <div className='counter'>
                <h2 className='count' >
                  {/* {count} */}
                  <CountUp 
                      key={currentIndex} 
                      start={ currentStat.isAUM ? 1_000_000_000 : 0 } end={currentStat.count} 
                      duration={2} 
                      separator="," 
                      prefix={currentStat.prefix} 
                      suffix={currentStat.suffix} 
                      formattingFn={ currentStat.isAUM ? formatAUM : undefined } 
                    />
                </h2>
                <h4 className='counttext'  >
                  {currentStat.text}
                </h4>
               
              </div>
            </Row>
          </Container>
          <Container>
            <Row>
              <div className='paragraph-div mt-5'>
                <p className='mobile-para'>
                Preferred Square provides offshore management consulting, investment advisory and business analytics support to family offices, fund managers, advisors and corporates across the globe. Through our long history of consulting projects with Family Offices and LPs, we've developed a unique vantage to enable our clients in critical areas of business ranging from business strategy to portfolio management to transaction advisory.
                </p>
              </div>
             
            </Row>
            <Row>
            <div className='btn-div pt-4'>
            <NavLink to='/about' onClick={scrollToTop}><button className='findout-btn'>Find out more about us</button></NavLink>
              </div>
            </Row>

          </Container>

        </section>

        <section className='wherewd-section mobile' >
          {/* <div className='wherewdbg'></div> */}
          <Container fluid>
            <Row className='w-100 p-0 m-0 row'>

              <Col className='col-12'>        
                <div className='content-box'>
                  <h2>Where do we</h2>
                  <div className="strok">Create Impact</div>
                  <div className="h1 anima">Create  <span className='anima-underline'>Imp</span>act</div>
                </div>
              </Col>        

            

              <Col className='col-12 pt-5'>

                <div >

                  <Swiper
                    slidesPerView={1}
                    spaceBetween={0}
                    centeredSlides={false}
                    loop={true}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    pagination={{
                      clickable: false,
                    }}
                    // pagination={false}
                    navigation={true}
                    modules={[ Pagination, Navigation]}
                    //modules={[Autoplay, Pagination, Navigation]}
                    className="mySwiper"
                  >

                    {sliderdata2.map((d, i) => (
                      <SwiperSlide key={i}>
                        <div className="slide-box">
                          <img src={d.img} alt="" />
                          <NavLink to={`/${d.link}`} onClick={scrollToTop}>
                          <div className="text-box">
                            <div className="heading">{d.title} </div>
                            <div className="text">{d.text} </div>
                          </div>
                          </NavLink>
                        </div>

                      </SwiperSlide>
                    ))}


                  </Swiper>
                </div>

               <div className='btn-div'>
               <NavLink to='/service' onClick={scrollToTop}><button className="findout-btn">Find out more about us</button></NavLink>
               </div>

              </Col>

            </Row>
          </Container>
        </section>


      </div>
    </>
  )
}
